import { render, staticRenderFns } from "./TopBrokers.vue?vue&type=template&id=622c628b&"
import script from "./TopBrokers.vue?vue&type=script&lang=js&"
export * from "./TopBrokers.vue?vue&type=script&lang=js&"
import style0 from "./TopBrokers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports